export const babyface = 'https://cafvifwe10507.edge.naverncp.com';

export const getCDNUrl = (dir, fileName) => `${babyface}/${dir}/${fileName}`;
